import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import './ad.controls.css';
import AdVolume from './ad.volume';
import AdLabel from './ad.label';
import AdSkip from './ad.skip';
import AdBar from './ad.bar';

import ThemeContext from '../../../config/themeContext';

export default function AdControls({ config, adVideo }) {
  const theme = useContext(ThemeContext);

  function handlerClick() {
    adVideo.resume();
  }

  const classShowSkip = adVideo.showSkip
    ? 'tpx-ext-controls-down show-skip'
    : 'tpx-ext-controls-down ';
  return (
    <>
      <div className="tpx-ext-controls-up">
        <AdVolume config={config} adVideo={adVideo} />
      </div>
      <div className="txp-ext-control-play" onClick={handlerClick}>
        <PlayCircleFilledWhiteIcon sx={theme.imageIconBig} />
      </div>
      <div className={classShowSkip}>
        <div>
          <AdLabel labelText={'ad'} cid={adVideo.cid || 0} />
          <div className="tpx-ext-control-space"></div>
          <AdSkip adVideo={adVideo} />
        </div>
        <div className="tpx-ext-progress-container">
          <AdBar config={config} adVideo={adVideo} />
        </div>
      </div>
    </>
  );
}

AdControls.propTypes = {
  config: PropTypes.object.isRequired,
  adVideo: PropTypes.object,
};
